import React, { useState } from "react";
import "./FaqSection.css";
import faq from "../data/faq.json";
import { iconChevron as chevron } from "../data/assets";

export default function FaqSection() {
  const [openId, setOpenId] = useState(null);

  return (
    <section className="beef-faq beef-container">
      <h2 className="beef-faq__title">Frequently Asked Questions</h2>

      <div className="beef-faq__list">
        {faq.map((item) => {
          const isOpen = openId === item.id;
          return (
            <div
              key={item.id}
              className={
                "beef-faq__item" + (isOpen ? " beef-faq__item--open" : "")
              }
            >
              <button
                type="button"
                className="beef-faq__header"
                aria-expanded={isOpen}
                aria-controls={`beef-faq-panel-${item.id}`}
                onClick={() => setOpenId(isOpen ? null : item.id)}
              >
                <span className="beef-faq__q">{item.question}</span>
                <span className="beef-faq__chevron" aria-hidden="true">
                  <img src={chevron} alt="" />
                </span>
              </button>

              {isOpen && item.answer ? (
                <div
                  className="beef-faq__answer"
                  id={`beef-faq-panel-${item.id}`}
                  role="region"
                >
                  <p>{item.answer}</p>
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </section>
  );
}
